module.exports = __webpack_public_path__ + "img/logo-light.af9919f0.png";